var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from "react";
import { useWindowSize } from "./use-window-size";
export var useDimensionsFor = function (ref) {
  var _a = __read(React.useState({
      width: 0,
      height: 0
    }), 2),
    dimensions = _a[0],
    setDimensions = _a[1];
  var windowSize = useWindowSize();
  React.useEffect(function () {
    // setup reserved width
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      var width = ref.current.clientWidth;
      var height = ref.current.clientHeight;
      setDimensions({
        width: width,
        height: height
      });
    }
  }, [ref === null || ref === void 0 ? void 0 : ref.current, windowSize.width, windowSize.height]);
  return __assign({}, dimensions);
};